import { useEffect } from "react";
import { useThemeStore } from "../stores/themeStore";
import { karelImages } from "../../runtime/karelImages";
import {
  applyCanvasColors,
  applyFontClass,
  applyThemeClass,
  syncThemeFromStore,
} from "../theme/applyTheme";

/**
 * Keeps the document root in sync with the persisted theme/font preferences and
 * propagates canvas + editor colors whenever the theme changes.
 */
export function ThemeStyleProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const themeId = useThemeStore((s) => s.themeId);
  const fontId = useThemeStore((s) => s.fontId);

  useEffect(() => {
    applyThemeClass(themeId);
    applyCanvasColors();
    window.dispatchEvent(new Event("karel:theme-changed"));
    // The sprites are SVG data URIs baked at load time, so they need to be
    // regenerated from the new palette. Once ready they dispatch
    // `karel:images-updated`, which repaints the canvases.
    void karelImages.recolor();
  }, [themeId]);

  useEffect(() => {
    applyFontClass(fontId);
  }, [fontId]);

  useEffect(() => {
    syncThemeFromStore();
  }, []);

  return <>{children}</>;
}
